<div class="main-container">
    <div class="container-fluid">
        <div class="login pt-3 pb-2">
            <div class="login-section">
                <div class="loginSections d-flex justify-content-center">
                    <div class="me-4 rme-0 rmb-4">
                        <div class="login-form">
                            <div class="login-logo">
                                <img src="../../../assets/images/refresh-logo.svg" alt="">
                            </div>
                            <div class="row">
                                <div class="col-md-12 mt-3 text-center">
                                    <h3 class="l-wel mb-4">Contractor Portal</h3>
                                    <!-- <p class="mb-0">
                                        <mat-icon class="l-arrow-right">arrow_forward</mat-icon>
                                    </p> -->
                                    <div class="pt-1">
                                        <button mat-raised-button color="primary" type="submit" (click)="redirectToLogin('REFRESH')">Login</button>
                                    </div>
                                    <div class="mt-3">
                                        <span class="link" (click)="redirectToSignup('REFRESH')">Sign Up Here</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="ms-4 rms-0">
                        <div class="login-form">
                            <div class="login-logo">
                                <img src="../../../assets/images/zones-logo.svg" alt="">
                            </div>
                            <div class="row">
                                <div class="col-md-12 mt-3 text-center">
                                    <h3 class="l-wel mb-4">Contractor Portal</h3>
                                    <!-- <p class="mb-0">
                                        <mat-icon class="l-arrow-right">arrow_forward</mat-icon>
                                    </p> -->
                                    <div class="pt-1">
                                        <button mat-raised-button color="primary" type="submit" (click)="redirectToLogin('ZONES')">Login</button>
                                    </div>
                                    <div class="mt-3">
                                        <span class="link" (click)="redirectToSignup('ZONES')">Sign Up Here</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>